module.exports = __webpack_public_path__ + "static/media/orders-pen.9429d0c5.svg";